// @flow

import React from 'react';
import styled from 'styled-components';
import { Flex, Box } from '../../../../grid/index';
import type { Theme } from '../../../../../types/index';

type Props = {
  title: string,
};

const VideoThumb = styled<typeof Flex, Theme>(Flex)`
  color: ${props => props.theme.gallery.videoThumbColor};
  font-size: 0.75rem;
  text-align: center;
`;

const Icon = styled<any, Theme>('i')`
  font-size: 1.75rem;
  line-height: 0;
  &:before {
    vertical-align: middle;
  }
`;

export default ({
  title,
}: Props) => (
  <VideoThumb flexDirection="column" alignItems="center" justifyContent="center">
    <Icon className="icon-play" />
    <Box mt="0.5em">
      {title}
    </Box>
  </VideoThumb>
);
